import { EditRobotProps } from "./Details";
import AceEditor from "react-ace";
import "ace-builds/webpack-resolver"; // Ensure AceEditor is imported correctly

// Import AceEditor modes and themes if not already imported
import "ace-builds/src-noconflict/mode-yaml";
import "ace-builds/src-noconflict/mode-sh";
import "ace-builds/src-noconflict/theme-monokai";

export function Manifest({ robot, onChange, errors }: EditRobotProps) {
  return <AceEditor
    mode="yaml"
    theme="twilight"
    name="yaml-editor"
    fontSize={25}
    width="100%"
    height="100%"
    value={robot.yamlContent}
    onChange={val => {
      const updated = { ...robot, yamlContent: val };
      // console.log('Manifest', updated);
      onChange(updated);
    }}
    editorProps={{ $blockScrolling: true }}
    setOptions={{
      showLineNumbers: true,
      tabSize: 2,
    }}
  />;
}